import { render, staticRenderFns } from "./oddsItemMMO.vue?vue&type=template&id=819082a2&lang=pug&"
import script from "./oddsItemMMO.vue?vue&type=script&lang=js&"
export * from "./oddsItemMMO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports